import { message } from '@/components'
import { PAYMENT_TYPE } from '@/consts/billing'

export function usePaymentProcessing() {
  const openPopupWindow = (url: string, onOk: () => void) => {
    const width = 600
    const height = 800
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2

    const paymentWindow = window.open(
      url,
      'Charge',
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
    )

    // Listen for a message from the popup window to confirm payment status
    const handlePaymentMessage = (event: any) => {
      if (event.origin !== window.location.origin) return // Ignore messages from other origins
      if (event.data.id !== 'glows-paypal') return // Verify message is intended for us

      if (event.data.success) {
        message.success('Payment successful')
        onOk() // Execute onOk callback on success
      }
      paymentWindow?.close()
    }

    window.addEventListener('message', handlePaymentMessage)

    // Remove the message event listener once the payment process is complete
    return () => {
      window.removeEventListener('message', handlePaymentMessage)
    }
  }

  const submitPostForm = (url: string) => {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = url.split('?')[0]

    const urlParams = new URLSearchParams(url.split('?')[1])
    const requiredParams = ['MerchantID', 'TradeInfo', 'TradeSha', 'Version']

    requiredParams.forEach((param) => {
      const value = urlParams.get(param)
      if (value) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = param
        input.value = value
        form.appendChild(input)
      }
    })

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  const processPayment = (url: string, paymentType: number, onOk: () => void) => {
    if (paymentType === PAYMENT_TYPE.PAYPAL) {
      // Open a new popup window for type 6 payments (PayPal)
      openPopupWindow(url, onOk)
    } else if (paymentType === PAYMENT_TYPE.NEWEBPAY) {
      // Submit a POST request to the provided URL for type 7 payments (NewebPay)
      submitPostForm(url)
    } else if (paymentType === PAYMENT_TYPE.STRIPE) {
      window.open(url, '_blank')
    }
  }

  return { processPayment }
}
